import { defineStore } from 'pinia'
import api from '@/services/api'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    token: localStorage.getItem('token'),
    user: null,
    isAuthenticated: false
  }),

  getters: {
    isLoggedIn: (state) => !!state.token && state.isAuthenticated,
    currentUser: (state) => state.user
  },

  actions: {
    async initializeAuth() {
      const token = localStorage.getItem('token')
      if (token) {
        this.token = token
        try {
          await this.fetchUser()
          return true
        } catch (error) {
          console.error('Failed to initialize auth:', error)
          this.logout()
          return false
        }
      }
      return false
    },

    async login(username, password) {
      try {
        const params = new URLSearchParams()
        params.append('username', username)
        params.append('password', password)

        console.log('Login request:', {
          url: 'api/v1/auth/token',
          params: params.toString(),
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })

        const response = await api.post('api/v1/auth/token', params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        
        // The response itself is the data we need
        const data = response || {}
        
        console.log('Login response data:', data)

        if (!data.access_token) {
          console.error('Invalid response structure:', data)
          throw new Error('No access token received')
        }

        const token = data.access_token
        this.token = token
        localStorage.setItem('token', token)
        
        await this.fetchUser()
        return true
      } catch (error) {
        console.error('Login failed:', {
          message: error.message,
          response: error.response,
          data: error.response?.data
        })
        
        this.logout()
        
        if (error.response?.status === 401) {
          throw new Error('Invalid username or password')
        } else if (error.response?.status === 422) {
          const detail = error.response.data?.detail || 'Invalid login format'
          throw new Error(detail)
        } else if (error.message === 'No access token received') {
          throw error
        } else {
          throw new Error(error.message || 'Login failed. Please try again.')
        }
      }
    },

    async fetchUser() {
      try {
        const response = await api.get('api/v1/users/me')
        const data = response || {}
        
        console.log('Fetch user response:', data)

        if (!data) {
          throw new Error('Invalid user data response')
        }

        this.user = data
        this.isAuthenticated = true
        return this.user
      } catch (error) {
        console.error('Failed to fetch user:', error)
        this.logout()
        throw error
      }
    },

    async verifyAuth() {
      if (!this.token) {
        return false
      }

      try {
        await this.fetchUser()
        return true
      } catch (error) {
        return false
      }
    },

    logout() {
      this.token = null
      this.user = null
      this.isAuthenticated = false
      localStorage.removeItem('token')
    }
  }
}) 